// tslint:disable-next-line:no-submodule-imports
import * as ActionTypes from 'found/lib/ActionTypes';

import { SetUserProfileAction } from '../../redux/actions/user';
import { EventDefinition, EventsMap } from '../types';

export function acTrackVisit(email) {
  // tslint:disable:no-string-literal
  if (window['acTrackVisit']) {
    window['acTrackVisit'](email);
  }
  // tslint:enable:no-string-literal
}

export const acTrackVisitOnSetProfile: EventDefinition<SetUserProfileAction> = ({ payload }) => {
  acTrackVisit(payload.profile.email);
};

const trackVisit: EventDefinition<unknown> = (_, __, { user }) => {
  const profile = user.profile;
  if (profile && profile.email) {
    acTrackVisit(profile.email);
  }

  // @ts-ignore
  window.dataLayer = window.dataLayer || [];
  // @ts-ignore
  window.dataLayer.push({
    event: 'pageview',
    pathname: document.location.pathname,
  });
};

export const acEventsMap: EventsMap = {
  [ActionTypes.RESOLVE_MATCH]: trackVisit,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/analytics/events/activecampaign.ts